import React from 'react';

const LoadingSpinner = ({ fullPage = false }) => {
    const wrapperClasses = fullPage ? "fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50" : "flex items-center justify-center py-12";

    return (
        <div className={wrapperClasses}>
            <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
    );
};

export default LoadingSpinner;
